import { render, staticRenderFns } from "./ApplicantRemarks.vue?vue&type=template&id=aa83685a&"
import script from "./ApplicantRemarks.vue?vue&type=script&lang=ts&"
export * from "./ApplicantRemarks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa83685a')) {
      api.createRecord('aa83685a', component.options)
    } else {
      api.reload('aa83685a', component.options)
    }
    module.hot.accept("./ApplicantRemarks.vue?vue&type=template&id=aa83685a&", function () {
      api.rerender('aa83685a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/Application/Sections/ApplicantRemarks.vue"
export default component.exports